export enum MUTATION_KEYS {
  CREATE_TEMPLATE_ATTRIBUTE = 'CREATE_TEMPLATE_ATTRIBUTE',
  UPDATE_TEMPLATE_ATTRIBUTE = 'UPDATE_TEMPLATE_ATTRIBUTE',
  DELETE_TEMPLATE_ATTRIBUTE = 'DELETE_TEMPLATE_ATTRIBUTE',
  CREATE_TABLE = 'CREATE_TABLE',
  UPDATE_TABLE = 'UPDATE_TABLE',
  DELETE_TABLE = 'DELETE_TABLE',
  BULK_UPDATE_TEMPLATE_ATTRIBUTES = 'BULK_UPDATE_TEMPLATE_ATTRIBUTES',
  BULK_DELETE_TEMPLATE_ATTRIBUTES = 'BULK_DELETE_TEMPLATE_ATTRIBUTES',
}

export default MUTATION_KEYS
